"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SCALE_PRESENTER_BANNERS_ON_CAMERAS_EXCEEDING = exports.ROUNDED_BOTTOM_BORDER_RADIUS = exports.PRESENTER_BANNER = exports.NO_BORDER_RADIUS = exports.MAX_PRESENTER_BANNERS_CHARACTERS = exports.HIDE_DESCRIPTION_ON_COUNT_EXCEEDING = exports.BANNER_TEMPLATE = exports.BANNER_PLACEHOLDERS = exports.BANNER_DELETE = exports.BANNER_ANIMATION_STYLES = void 0;
var _Sources = require("./Sources");
var BANNER_ANIMATION_STYLES = exports.BANNER_ANIMATION_STYLES = ['Slide Right', 'Slide Left', 'Slide Up', 'Wipe Right', 'Wipe Left', 'Wipe Up', 'Dissolve In', 'Instant'];
var PRESENTER_BANNER = exports.PRESENTER_BANNER = 'presenterBanner';
var BANNER_TEMPLATE = exports.BANNER_TEMPLATE = {
  title: '{bannerName}',
  value: {
    templateId: '',
    templateVars: {
      LINE_1: 'Presenter name',
      LINE_2: 'Presenter title',
      ACCENT_COLOR: '#FFEA7F'
    },
    autoLeave: false,
    transitionStyle: '',
    templateType: ''
  },
  type: _Sources.BANNER
};
var BANNER_PLACEHOLDERS = exports.BANNER_PLACEHOLDERS = {
  title: 'Presenter name',
  description: 'Presenter title',
  heading_font: 'HEADING_FONT',
  body_font: 'BODY_FONT',
  heading_font_url: 'HEADING_FONT_URL',
  body_font_url: 'BODY_FONT_URL'
};
var HIDE_DESCRIPTION_ON_COUNT_EXCEEDING = exports.HIDE_DESCRIPTION_ON_COUNT_EXCEEDING = 6;
var SCALE_PRESENTER_BANNERS_ON_CAMERAS_EXCEEDING = exports.SCALE_PRESENTER_BANNERS_ON_CAMERAS_EXCEEDING = 5;
var MAX_PRESENTER_BANNERS_CHARACTERS = exports.MAX_PRESENTER_BANNERS_CHARACTERS = 20;
var BANNER_DELETE = exports.BANNER_DELETE = 'bannerDelete';
var NO_BORDER_RADIUS = exports.NO_BORDER_RADIUS = '0px 0px 0px 0px';
var ROUNDED_BOTTOM_BORDER_RADIUS = exports.ROUNDED_BOTTOM_BORDER_RADIUS = '0px 0px 8px 8px';